import { Link, useSearchParams } from "react-router";
import { currentLang, pickLang, tr } from "../lib/sprache";
import { PublicLayout } from "../components/shell/WebLayout";

/**
 * Fangweg für unbekannte Adressen (SICHT-OEFFENTLICH-BETRIEB-18): vorher die Baustellen-Seite mit dem Standardtext
 * „Diese Seite wird gerade nach dem Design-Paket gebaut.“ – für vertippte oder veraltete Links irreführend.
 * Rahmen wie alle öffentlichen Zustandsseiten (Link abgelaufen, Link ungültig): Kopf mit Logo und Hell/Dunkel, Karte in
 * der Mitte (Portal einheitlich, 30.09.2026).
 */
export function NichtGefunden() {
  // Sprache wie auf den anderen eigenständigen Seiten: ?sprache=en im Link, sonst die zuletzt gewählte Oberflächensprache
  const [params] = useSearchParams();
  const lang = pickLang(params.get("sprache"), currentLang());
  const t = (de: string, en: string) => tr(lang, de, en);
  return (
    <PublicLayout lang={lang}>
      <title>{t("Seite nicht gefunden · CreatorOffice", "Page not found · CreatorOffice")}</title>
      <meta name="robots" content="noindex, nofollow" />
      <main id="main" className="auth-shell stack">
        <section className="centerform panel stack">
          <h1>{t("Seite nicht gefunden", "Page not found")}</h1>
          <p>{t("Diese Adresse gibt es nicht (mehr). Prüfe den Link oder geh zur Startseite.", "This address does not exist (any more). Check the link or go to the start page.")}</p>
          <div className="row"><Link className="btn primary" to="/">{t("Zur Startseite", "To the start page")}</Link></div>
        </section>
      </main>
    </PublicLayout>
  );
}
